import { auth } from "../utils/firebase";
import { OAuthProvider, signInWithPopup } from "firebase/auth";

export default class AppleSignInService {

  static async signInWithApple() {
    try {
      const provider = new OAuthProvider("apple.com");
      provider.addScope("email");
      provider.addScope("name");
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const isNewUser = result?.additionalUserInfo?.isNewUser ?? false;
      console.log("✅ Apple login success:", user);
      return {
        success: true,
        userId: user.uid,
        email: user.email || "",
        isNewUser
      };
    } catch (error) {
      console.error("❌ Apple login error:", error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}